var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPathology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.0013H2",
    stroke: "#FFB776",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.6693H4.66667",
    stroke: "#FFB776",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27529 6.94389C5.75459 6.42321 5.75459 5.57899 6.27529 5.05829L9.05635 2.27724C9.57701 1.75654 10.4213 1.75654 10.9419 2.27724L11.0564 2.39169C11.5771 2.9124 11.5771 3.75663 11.0564 4.27732L8.27528 7.05836C7.75461 7.57902 6.91041 7.57902 6.38969 7.05829L6.27529 6.94389Z",
    stroke: "#FFB776",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 8L6.33203 7",
    stroke: "#FFB776",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1102 4.33594C12.4567 5.30401 13.3337 6.8842 13.3337 8.66927C13.3337 11.6148 10.9459 14.0026 8.00033 14.0026C5.76209 14.0026 3.84587 12.6238 3.05469 10.6693",
    stroke: "#FFB776",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathology);
export default __webpack_public_path__ + "static/media/pathology.b58f88306777e48db335908c7c8ade81.svg";
export { ForwardRef as ReactComponent };